// src/App.jsx
// Root app component - particle grid runs behind everything

import React from 'react';
import Header from './components/sections/Header';
import Footer from './components/sections/Footer';
import LandingPage from './pages/LandingPage';
import BackToTop from './components/ui/BackToTop';

// Import firebase to initialise analytics
import './firebase';

const App = () => {
  return (
    <div className="min-h-screen bg-gt-silver-50 text-gt-dark-100">
      <Header />
      <main>
        <LandingPage />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default App;